const content = {
    tiktok_data_export: {
      en: {
        simple_summary_no_video_html: '',
        simple_steps: [
          {
            step_type: 'numbered_step',
            number: '1',
            description_html: '<p>To upload your data, simply click <b>"Choose File"</b> below; find the ZIP file you saved and upload it.</p>'
          },
          {
            step_type: 'numbered_step',
            number: '2',
            description_html: '<p>Since some files are large, we recommend being connected to Wi-Fi so that the upload process is as fast as possible.</p>'
          },
          {
            step_type: 'emoji_step',
            emoji: '💡',
            description_html: '<p>PLEASE NOTE THAT WE USE A SECURE UPLOADING SERVICE TO PROTECT YOUR DATA AND PRIVACY.</p>'
          }
        ],
        summary_no_video_html: ` 
        <p>You completed part one of this Retro task a few days ago, which asked you to request your data from TikTok. This is part two — download and share your TikTok data. Here are the steps:</p>  
        `,
        steps: [
          {
            step_type: 'numbered_step',
            number: '1',
            description_html: `<p>Open the TikTok app on your phone.</p>`
          },
          {
            step_type: 'numbered_step',
            number: '2',
            description_html: `<p>Tap on <b>Profile</b> in the bottom-right.</p>`
          },
          {
            step_type: 'numbered_step',
            number: '3',
            description_html: `<p>Now top on the "hamburger" menu (with three horizontal lines) in the top-right.</p>`
          },
          {
            step_type: 'numbered_step',
            number: '4',
            description_html: `<p>Tap on <b>Settings and Privacy</b> (at the bottom of the screen).</p>`
          },
          {
            step_type: 'numbered_step',
            number: '5',
            description_html: `<p>Select <b>Manage Account</b>.</p>`
          },
          {
            step_type: 'numbered_step',
            number: '6',
            description_html: `<p>Select <b>Download your Data</b>.</p>`
          },
          {
            step_type: 'numbered_step',
            number: '7',
            description_html: `<p>At the top of the screen tap on <b>Download data</b>.</p>`
          },
          {
            step_type: 'numbered_step',
            number: '8',
            description_html: `
              <p>Tap the red <span style="color:red; font-weight: bold">Download</span> button.</p>
              <p><i>You may be asked to login and verify your identity.</i></p>
              `
          },
          {
            step_type: 'numbered_step',
            number: '9',
            description_html: `<p>After that, a pop message will appear that asks you if you would like to "download your data" — select <b>Yes</b>.</p>`
          },
          {
            step_type: 'numbered_step',
            number: '10',
            description_html: `<p>Tap the <span style="color:blue; font-weight: bold">blue arrow</span> in the bottom-left corner of your screen.</p>`
          },
          {
            step_type: 'numbered_step',
            number: '11',
            description_html: `<p>A menu will appear — choose <b>Download</b>.</p>`
          },
          {
            step_type: 'emoji_step',
            emoji: '💡',
            description_html: `
              <p>You will be taken to the Downloads area of your phone. There should be a .zip file named <b>TikTok_Data</b> with today's
              date and time. This is your downloaded data file.</p>`
          },
          {
            step_type: 'numbered_step',
            number: '12',
            description_html: `<p>Return to the MSR app, tap on <b>Choose file</b>, and select the <b>TikTok_Data</b> file.</p>`
          }
        ],
        part_1_instructions_link: 'https://help.measureprotocol.com/en/support/solutions/articles/80001128762-tiktok-data-file-retro-instructions'
      },
      es: {
        simple_summary_no_video_html: '',
        simple_steps: [
          {
            step_type: 'numbered_step',
            number: '1',
            description_html: '<p>Para subir tus datos, simplemente haz clic en <b>"Elegir archivo"</b> abajo; encuentra el archivo ZIP que acabas de guardar y súbelo.</p>'
          },
          {
            step_type: 'numbered_step',
            number: '2',
            description_html: '<p>Dado que algunos archivos son grandes, te recomendamos estar conectado a Wi-Fi para que el proceso de subida sea lo más rápido posible.</p>'
          },
          {
            step_type: 'emoji_step',
            emoji: '💡',
            description_html: '<p>POR FAVOR, TEN EN CUENTA QUE UTILIZAMOS UN SERVICIO DE SUBIDA SEGURO PARA PROTEGER TUS DATOS Y TU PRIVACIDAD.</p>'
          }
        ],
        data_type_description: 'X Data Upload',
      },
      pt: {
        simple_summary_no_video_html: '',
        simple_steps: [
          {
            step_type: 'numbered_step',
            number: '1',
            description_html: '<p>Para fazer o upload dos seus dados, simplesmente clique em <b>"Escolher Arquivo"</b> em baixo — encontre o ficheiro ZIP que acabou de guardar e faça o upload do mesmo.</p>'
          },
          {
            step_type: 'numbered_step',
            number: '2',
            description_html: '<p>Como alguns ficheiros são grandes, sugerimos que esteja conectado ao Wi-Fi para tornar o processo de upload o mais rápido possível.</p>'
          },
          {
            step_type: 'emoji_step',
            emoji: '💡',
            description_html: '<p>POR FAVOR, NOTE QUE USAMOS UM SERVIÇO DE UPLOAD SEGURO PARA PROTEGER SEUS DADOS E A SUA PRIVACIDADE.</p>'
          }
        ],
        data_type_description: 'X Data Upload',
      }
    },
};

export const bytedanceDataTypes = {
    tiktok_data_export: {
        data_type: 'tiktok_data_export',
        data_type_description: 'TikTok Data Export',
        require_consent: true,
        logo: 'https://d3s00xghdjywqy.cloudfront.net/c2/retro/tiktok_data_export/logo.png',
        capture_type: 'file',
        use_in_app_screen_recorder: false,
        generic: {
            ...content.tiktok_data_export,
        }
    },
}